<template>
  <v-menu
    v-if="note"
    :attach="`#${attachId}`"
    bottom
    left
    :nudge-bottom="nudgeBottom"
    :open-on-hover="!isIOSSafari()"
    :open-on-click="isIOSSafari()"
    :close-on-content-click="false"
    content-class="note-tooltip"
  >
    <template #activator="{ on }">
      <v-icon
        v-on="on"
        :size="iconSize"
        color="#F39F18"
        class="ml-1"
        onclick=""
      >
        {{ icons.mdiInformationOutline }}
      </v-icon>
    </template>
    <template #default>
      <v-card
        color="#8DCDC1"
        width="275"
        max-width="275"
      >
        <v-card-text style="padding: 10px">
          <div
            v-html="note"
            class="tiptap-data"
          />
        </v-card-text>
      </v-card>
    </template>
  </v-menu>
</template>

<script>
import {mdiInformationOutline} from "@mdi/js"

/**
 * Tooltip с примечанием (например, к врачу)
 */
export default {
  props: {
    note: String,
    iconSize: {
      type: Number,
      default: 30
    },
    nudgeBottom: {
      type: Number,
      default: 30
    },
    attachId: String
  },
  data() {
    return {
      icons: {
        mdiInformationOutline
      }
    }
  },
  methods: {
    /**
     * Детектор браузера Safari on iOS
     */
    isIOSSafari() {
      return /iP(ad|od|hone)/i.test(window.navigator.userAgent) &&
        /WebKit/i.test(window.navigator.userAgent) &&
        !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent))
    }
  }
}
</script>

<style scoped>
.note-tooltip {
  background: #8DCDC1;
  border-radius: 20px;
  box-shadow: none;
}
</style>